"use client"

import styled, { css } from "styled-components"

import { theme as defaultTheme } from "@/theme"

export const ContentContainer = styled.div`
  ${({ theme = defaultTheme, $column, $overflow, $marginBottom, $smallPadding, $noPadding }) => {
    const { borders, colors, spaces } = theme
    return css`
      display: flex;
      flex-direction: ${$column && "column"};
      gap: ${spaces.small};
      height: ${!$overflow && "fit-content"};
      overflow-y: ${$overflow && "auto"};
      background-color: ${colors.content.bg};
      padding: ${$noPadding ? 0 : $smallPadding ? spaces.xtrasmall : spaces.small};
      border-radius: ${borders.radius.standard};
      margin-bottom: ${$marginBottom ? theme.spaces.small : "0"};
    `
  }}
`
